import React from "react";
import { useConfig } from "../AppContext";
import { useSelector } from "react-redux";
import { isAdminIntegration } from "../store/statePresenter";
import { persistCampaigns, } from "../helpers/campaign-manager";
export var useCampaignName = function (searchParams) {
    if (searchParams === void 0) { searchParams = ""; }
    var isAdmin = useSelector(isAdminIntegration);
    var _a = React.useRef(useConfig("campaignName")).current, campaignName = _a[0], setCampaignName = _a[1];
    React.useEffect(function () {
        if (isAdmin)
            return;
        var store = persistCampaigns({ searchParams: searchParams, campaignName: campaignName });
        if (store) {
            setCampaignName(store);
        }
    }, [setCampaignName, searchParams, campaignName, isAdmin]);
};
